"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return GlobalStyles;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _utilityClasses = require("../util/utilityClasses");
const _useDefaultFont = require("../hooks/useDefaultFont");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const GlobalStyles = (param)=>{
    let { theme, useUtilityClasses, useWebSafeFontOnly = false, children } = param;
    const utilityClasses = (0, _react.useMemo)(()=>(0, _utilityClasses.utilityClasses)(theme), [
        theme
    ]);
    const font = (0, _useDefaultFont.useDefaultFont)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, children, /*#__PURE__*/ _react.default.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined",
        rel: "stylesheet",
        className: _style.default.dynamic([
            [
                "92d6998cddd4a0e5",
                [
                    !useWebSafeFontOnly ? _useDefaultFont.fontImports : "",
                    !useWebSafeFontOnly ? "".concat(font, ", ") : "",
                    theme.fontSize,
                    useUtilityClasses ? utilityClasses : ""
                ]
            ]
        ])
    }), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "92d6998cddd4a0e5",
        dynamic: [
            !useWebSafeFontOnly ? _useDefaultFont.fontImports : "",
            !useWebSafeFontOnly ? "".concat(font, ", ") : "",
            theme.fontSize,
            useUtilityClasses ? utilityClasses : ""
        ]
    }, "".concat(!useWebSafeFontOnly ? _useDefaultFont.fontImports : "", " *,*::before,*::after{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}*{font-family:").concat(!useWebSafeFontOnly ? "".concat(font, ", ") : "", "Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}body{font-size:").concat(theme.fontSize, "}p{line-height:1.5}h1,h2,h3,h4,h5,h6{font-weight:400}h1{font-size:24px}h2{font-size:22px}h3{font-size:20px}h4{font-size:18px}").concat(useUtilityClasses ? utilityClasses : "", " svg{vertical-align:middle!important}input:-moz-read-only{cursor:default}input:read-only{cursor:default}")));
};

//# sourceMappingURL=GlobalStyles.js.map